<template>
  <v-card 
    class="policyCard" 
    :class="{'policyNewButton primary':!policy.id, 'dense':dense,'primary':selected, 'noClick': noClick}" 
    :flat="!policy.id" 
    @click="$emit('on-click')"
    :ripple="(noClick ? false : true)"
  >
    <v-card-text class="policyCardText" v-if="policy.id">
      <div class="cardIcon">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
        
            <span v-on="on">
              <v-icon v-if="selected" class="white--text">mdi-check</v-icon>
              <v-icon v-else-if="policy.type == 'WHOLE'">mdi-account-child-circle</v-icon>
              <v-icon v-else-if="policy.type == 'UNIVERSAL'">mdi-earth</v-icon>
            </span>
          </template>
          <span>
            {{ policy.type.charAt(0) + policy.type.substring(1).toLowerCase() + ' Life'}}
          </span>
        </v-tooltip>
      </div>
      
      <div class="title" :class="{'mb-2':!dense,'white--text':selected}"><span>{{ policy.name }}</span></div>
      <div class="subtitle-1" >
        <v-row no-gutters class="align-center">
          <v-col class="flex-shrink-1 flex-grow-0 text-no-wrap subtitle-1" :class="{'white--text':selected}">
            {{ provider }}
          </v-col>
          <v-col class="caption text-right pr-12" :class="{'white--text':selected}">
            {{ premium }}
          </v-col>
        </v-row>
      </div>
      <div class="cardDelete" v-if="!hideDelete">
        <v-btn x-small text color="error" v-on:mousedown.stop="$emit('on-delete')">{{ deleteText }}</v-btn>
      </div>
    </v-card-text>
    <v-icon v-else class="white--text">mdi-plus</v-icon>
  </v-card>
</template>

<script>

export default {
  name: 'HouseholdsPolicyCard',
  props: {
    policy: {
      type: Object,
      required: true
    },
    hideDelete: Boolean,
    dense: Boolean,
    selected: Boolean,
    deleteText: {
      type: String,
      default: 'Delete'
    },
    noClick: Boolean
  },
  data () {
    return {
    }
  },
  computed: {
    provider() {
      if(!this.policy.provider) return ''
      let text  = this.policy.provider.split('_')
      let final = []
      text.forEach(a => {
        final.push( a.charAt(0).toUpperCase() + a.substring(1).toLowerCase() )
      })
      return final.join(' ')
    },
    premium() {
      if(!this.policy.premium) return null
      if(this.policy.annual) return this.$options.filters.currencyRounded(this.policy.premium) + ' / Year'
      return this.$options.filters.currencyRounded(this.policy.premium / 12) + ' / Month'
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/_mixins.scss';

  .policyCard {
    height: 100px;
    cursor: default;
    transition-property: background-color,box-shadow,transform,opacity;
    transition-duration: .2s;
    transition-timing-function: ease-in-out;

    ::v-deep .cardDelete {
      transition: opacity .4s ease-in-out;
      opacity: 0;
      position: absolute;
      bottom: 5px;
      right: 5px;
    }

    &:hover {

      &:not(.noClick) {
        box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12);
        transform: scale(1.02);
        cursor: pointer;
      }

      ::v-deep .cardDelete {
        opacity: 1;
      }
    }
    &.primary:not(.policyNewButton) {
      transform: scale(1.06);
    }
  }
  .debtCardText {
    height: 100%;
  }
  .cardIcon {
    position: absolute;
    top: 5px;
    right: 5px;
    ::v-deep i {
      font-size: 60px !important;
      opacity: .2;
    }
    ::v-deep i.white--text {
      opacity: 1;
    }
  }
  .policyNewButton {
    &:hover {
      opacity: .8;
      box-shadow: none;
    }
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    ::v-deep i {
      font-size: 40px !important;
    }
  }
  
  .policyCard.dense {
    height: 50px;
    ::v-deep div {
      display: flex;
      flex-basis: 1;
    }
    ::v-deep .cardIcon {
      position: relative;
      top: unset;
      right: unset;
      ::v-deep i {
        font-size: 22px !important;
      }
    }
    ::v-deep .display-1 {
      font-size: 16px !important;
      line-height: unset;
      text-align: right;
      justify-content: flex-end;
      width: 80px;
      min-width: 80px;
      max-width: 80px;
      padding: 0px !important;
    }
    ::v-deep .subtitle-2 {
      flex: 1;
      margin-left: 4px;
      min-width: 0px;
      flex-grow: 1;
      span {
        white-space: nowrap;
        overflow: hidden;
        line-height: unset;
        text-overflow: ellipsis;
      }
    }
  }
</style>